import React from 'react';
import { useNewCheckIncompleteAptitudeQuery } from './NewAptitudeQuizSlice';
import Loading from 'components/global/layout/Loading';
import NewStartAptitudeTestScreen from './NewStartAptitudeTestScreen';
import NewGetAptitudeQuestion from './NewGetAptitudeQuestion';

const NewCheckQuizStatus = () => {
  // changed this: useNewCheckIncompleteAptitudeQuery , according to new aptitude slice
  const { isLoading, isSuccess, data } = useNewCheckIncompleteAptitudeQuery();
  const condition = isSuccess && Boolean(data.responses);

  return (
    <div>
      {isLoading ? (
        <Loading />
      ) : condition ? (
        <div>
          <NewStartAptitudeTestScreen data={data} />
        </div>
      ) : (
        <NewGetAptitudeQuestion />
      )}
    </div>
  );
};

export default NewCheckQuizStatus;
